import axios from "axios";
import { getItem } from "./LocalStorageManager";

const privateFetch = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_CONTEXT
});

privateFetch.interceptors.request.use(
  async (config) => {
    const token = await getItem("token");

    // 🔴 SIEMPRE enviar token si existe
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export { privateFetch };
